// extracted by mini-css-extract-plugin
export default {"root":"_1i2LOWZW","messengers-list":"_3K1476ou","messengersList":"_3K1476ou"};